const translations = {
  fr: {
    spots: {
      modifySelected: 'Modifier {{ count }} spot sélectionné',
      modifySelected_plural: 'Modifier {{ count }} spots sélectionnés',
      deleteSelected: 'Supprimer la sélection',
      deleteTheSelectedSpots: 'supprimer le spot sélectionné',
      deleteTheSelectedSpots_plural: 'supprimer les spots sélectionnés',
      applyChanges: 'Appliquer les changements',
      spots: 'Spots',
      countedSpots: 'spot',
      countedSpots_plural: 'spots',
      save: 'Sauvegarder',
      addSpots: 'Ajouter des spots',
      add: 'Ajouter',
      noSpots: 'Il n\'y a pas de spots à afficher',
      duration: 'Durée',
      date: 'Date',
      time: 'Heure',
      increment: 'Incrément',
      reach: 'Portée',
      modifyDate: 'Modifier la date',
      modifyTime: 'Modifier l\'heure',
      modifyDuration: 'Modifier la durée',
      modifyCampaign: 'Modifier la campagne',
      close: 'Fermer',
      modify: 'Modifier',
      spotsToBeSaved: 'Spots à sauvegarder',
      notAvailable: 'N/D',
      seconds: 'seconde',
      seconds_plural: 'secondes',
      updateSpotsError: 'Une erreur est survenue lors de la mise à jour des spots',
      updateSpotsSuccess: 'Les spots ont étés mis à jour',
      deleteSpotsSuccess: 'Les spots ont étés supprimés',
      deleteSpotsError: 'Une erreur est survenue lors de la suppression des spots',
      addSpotsError: 'Une erreur est survenue lors de l\'ajout des spots',
      campaignLoadingError: 'Une erreur est survenue lors du chargement des campagnes',
      campaign: 'Campagne',
      noCampaign: 'Pas de campagne',
      defaultValues: 'Valeurs par défaut',
      mustSpecifyCampaign: 'Vous devez spécifier une campagne pour le spot',
      inventory: 'Inventaire',
    },
  },
  en: {
    spots: {
      modifySelected: 'Modify {{ count }} selected spot',
      modifySelected_plural: 'Modify {{ count }} selected spots',
      deleteSelected: 'Delete selected',
      deleteTheSelectedSpots: 'delete the selected spot',
      deleteTheSelectedSpots_plural: 'delete the selected spots',
      applyChanges: 'Apply changes',
      spots: 'Spots',
      countedSpots: 'spot',
      countedSpots_plural: 'spots',
      save: 'Save',
      addSpots: 'Add spots',
      add: 'Add',
      noSpots: 'There are no spots to display',
      duration: 'Duration',
      date: 'Date',
      time: 'Time',
      increment: 'Increment',
      reach: 'Reach',
      modifyDate: 'Modify the date',
      modifyTime: 'Modify the time',
      modifyDuration: 'Modify the duration',
      modifyCampaign: 'Change the campaign',
      close: 'Close',
      modify: 'Modify',
      spotsToBeSaved: 'Spots to be saved',
      notAvailable: 'N/A',
      seconds: 'second',
      seconds_plural: 'seconds',
      updateSpotsError: 'An error occured when updating the spots',
      updateSpotsSuccess: 'The spots have been updated',
      deleteSpotsSuccess: 'The spots have been deleted',
      deleteSpotsError: 'An error occurred when deleting the spots',
      addSpotsError: 'An error occured when adding the spots',
      campaignLoadingError: 'An error occured when loading the campaigns',
      campaign: 'Campaign',
      noCampaign: 'No campaign',
      defaultValues: 'Default values',
      mustSpecifyCampaign: 'You must specify a campaign where the spot will be added',
      inventory: 'Inventory',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/i18n/spots.js